import type {ScanResult} from "../3-perform-scan/scan-model/ScanResult.tsx";
import {isDetailed} from "../3-perform-scan/scan-model/SharedJobResult.ts";
import {Button, Tooltip} from "@matillion/component-library";
import {
    generateSharedJobMigrationJson
} from "../5-download-artifacts/artifacts/shared-pipelines/generateSharedJobMigrationJson.ts";
import {download} from "./download.ts";
import {useState} from "react";

const TooltipContent = "When importing jobs to DPC, a mapping file is required to migrate Shared Job components. This button will generate a mapping file for you."

interface Props {
    scan: ScanResult
}
export function DownloadSharedJobMigrationButton({scan}: Props) {
    const {sharedJobs} = scan
    const [errored, setErrored] = useState(false)
    if(!isDetailed(sharedJobs)) return null
    //Check if any shared jobs are used
    if(!Object.values(scan.jobScan.problemIndicators?.sharedJobCount ?? {}).some(x => x > 0)) return null
    return <Tooltip content={TooltipContent}><Button
        alt="secondary" disabled={errored}
        onClick={()=> {
            const data = generateSharedJobMigrationJson(sharedJobs)
            if(data) {
                download(data, "shared-job-migration.json")
            } else {
                setErrored(true)
            }
        }}
    >
        Download Shared Job Mapping
        {errored && <span className="text-red-500">Failed to generate mapping file</span>}
    </Button></Tooltip>
}